import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { listingsAccessState, memberState } from "../state/atoms";
import YextApi from "../api/YextApi";

let pending: Promise<boolean> | null = null;

function fetchAccess(memberId: number, ownerId: number): Promise<boolean> {
  if (!pending) {
    pending = YextApi.listingsAccess(memberId, ownerId)
      .then(({ data }) => data.allowed === true)
      .catch(() => false)
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

export function useListingsAccess(): boolean | null {
  const member = useRecoilValue(memberState);
  const [allowed, setAllowed] = useRecoilState(listingsAccessState);
  const memberId = member.internalId;
  const ownerId = member.ownerId;

  useEffect(() => {
    if (allowed !== null || !member.logged || (!memberId && !ownerId)) return;
    let cancelled = false;
    fetchAccess(memberId, ownerId).then((result) => {
      if (!cancelled) setAllowed(result);
    });
    return () => {
      cancelled = true;
    };
  }, [allowed, member.logged, memberId, ownerId, setAllowed]);

  return allowed;
}
